import React from 'react'

const InfluencerDetailSkeleton = () => {
  return (
    <div className="border border-lightGray rounded-2xl overflow-hidden">
      <div className='md:py-10 py-5 px-5 bg-gradient-to-br from-secondary to-primary flex md:items-center justify-between max-md:flex-col max-md:gap-5'>
        <div className='flex items-center gap-5 text-white flex-1'>
          <div className='min-w-[70px] w-[70px] h-[70px] rounded-full overflow-hidden bg-gray animate-pulse'></div>
          <div className='flex flex-col gap-1.5'>
            <h5 className='rounded bg-gray animate-pulse w-40 h-9'></h5>
            <span className='rounded bg-gray animate-pulse w-32 h-8'></span>
          </div>
        </div>
        <div className='flex items-center lg:gap-16 gap-8 text-white flex-1 justify-end'>
          <div className='flex flex-col gap-0.5'>
            <h6 className='rounded bg-gray animate-pulse w-12 h-7'></h6>
            <span className='rounded bg-gray animate-pulse w-20 h-6'></span>
          </div>
          <div className='flex flex-col gap-0.5'>
            <h6 className='rounded bg-gray animate-pulse w-12 h-7'></h6>
            <span className='rounded bg-gray animate-pulse w-20 h-6'></span>
          </div>
        </div>
      </div>
      <div className="py-10 px-5">
        <div className="grid grid-cols-12 gap-3">
          <div className="md:col-span-8 col-span-12">
            <div className="border-b border-lightGray pb-5">
              <h3 className="rounded bg-gray animate-pulse w-16 h-7 mb-2"></h3>
              <p className='rounded bg-gray animate-pulse w-full h-28 mb-2'></p>

              <h3 className="rounded bg-gray animate-pulse w-16 h-7 mb-2"></h3>
              <div className='flex flex-wrap gap-2.5'>
                <span className='rounded bg-gray animate-pulse w-16 h-6'></span>
                <span className='rounded bg-gray animate-pulse w-16 h-6'></span>
                <span className='rounded bg-gray animate-pulse w-16 h-6'></span>
              </div>
            </div>
            <div className="mt-4">
              <div className='flex flex-col gap-6'>
                <div className='flex items-center gap-5'>
                  <div className="rounded bg-gray animate-pulse w-16 h-9"></div>
                  <div className="rounded bg-gray animate-pulse w-16 h-9"></div>
                </div>
                <div className="rounded bg-gray animate-pulse w-full h-24"></div>
              </div>
            </div>
          </div>
          <div className="md:col-span-4 col-span-12">
            <div className="border border-lightGray p-5 rounded-2xl min-h-[250px] xl:min-h-[350px]">
              <h3 className="mb-2 rounded bg-gray animate-pulse w-16 h-7"></h3>
              <div className='grid grid-cols-3 gap-2.5'>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
                <div className='rounded bg-gray animate-pulse w-full h-full overflow-hidden aspect-square'></div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="mt-8 mb-7 rounded bg-gray animate-pulse w-32 h-7"></h3>
        <div className='grid grid-cols-5 gap-4' >
          <div className='w-full h-full overflow-hidden rounded-xl aspect-square relative bg-gray animate-pulse'></div>
          <div className='w-full h-full overflow-hidden rounded-xl aspect-square relative bg-gray animate-pulse'></div>
          <div className='w-full h-full overflow-hidden rounded-xl aspect-square relative bg-gray animate-pulse'></div>
          <div className='w-full h-full overflow-hidden rounded-xl aspect-square relative bg-gray animate-pulse'></div>
          <div className='w-full h-full overflow-hidden rounded-xl aspect-square relative bg-gray animate-pulse'></div>
        </div>
      </div>
    </div>
  )
}

export default InfluencerDetailSkeleton
